import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import useMagneticEffect from "../../hooks/useMagneticEffect";

export default function MagneticButton({
  to,
  href,
  variant = "primary",
  children,
  className = "",
  external = false,
  ...rest
}) {
  const { ref, onMouseMove, onMouseLeave } = useMagneticEffect(0.22);

  const base =
    "group relative inline-flex items-center justify-center gap-2 overflow-hidden rounded-full px-7 py-3.5 text-sm font-semibold transition-[transform,box-shadow] duration-300 ease-out-expo focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2";

  const variants = {
    primary:
      "bg-primary-600 text-white shadow-[0_12px_40px_-12px_rgba(79,99,210,0.65)] hover:shadow-[0_16px_48px_-10px_rgba(79,99,210,0.75)] focus-visible:outline-primary-500",
    secondary:
      "border border-neutral-300/80 bg-white text-neutral-900 hover:border-primary-400/50 hover:bg-surface-accent focus-visible:outline-primary-500",
    ghost:
      "border border-white/20 bg-white/10 text-white backdrop-blur-sm hover:bg-white/15 focus-visible:outline-white/60",
  };

  const cls = `${base} ${variants[variant] || variants.primary} ${className}`;

  const inner = (
    <>
      <span className="relative z-10">{children}</span>
      <ArrowUpRight className="relative z-10 h-4 w-4 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
      {variant === "primary" ? (
        <span
          className="absolute inset-0 z-0 scale-x-0 bg-primary-700 transition-transform duration-500 ease-out-expo group-hover:scale-x-100"
          style={{ transformOrigin: "left center" }}
          aria-hidden
        />
      ) : null}
    </>
  );

  if (href) {
    return (
      <span ref={ref} className="inline-flex" onMouseMove={onMouseMove} onMouseLeave={onMouseLeave}>
        <a
          href={href}
          target={external ? "_blank" : undefined}
          rel={external ? "noopener noreferrer" : undefined}
          className={cls}
          {...rest}
        >
          {inner}
        </a>
      </span>
    );
  }

  return (
    <span ref={ref} className="inline-flex" onMouseMove={onMouseMove} onMouseLeave={onMouseLeave}>
      <Link to={to} className={cls} {...rest}>
        {inner}
      </Link>
    </span>
  );
}
